import IconArrowBack from '@vtex/styleguide/lib/icon/ArrowBack';
import IconClose from '@vtex/styleguide/lib/icon/Close';
import React from 'react';
import styles from './styles.module.css';

import type { Props } from './types';
import { Key } from './types';

type ContentProps = Required<
  Pick<
    Props,
    'onClose' | 'showCloseIcon' | 'children' | 'containerClassName' | 'type'
  >
> & { showBackIcon?: boolean; onClickBack?: () => void };

export default function ModalContent({
  onClose,
  showCloseIcon,
  showBackIcon,
  onClickBack,
  containerClassName,
  type,
  children,
  ...props
}: ContentProps) {
  const handleKeyDown = (event: React.KeyboardEvent) => {
    if (event.key !== Key.ESCAPE && event.key !== Key.ESC) {
      return;
    }

    event.stopPropagation();
    onClose();
  };

  const handleKeyPress = ({ key }: React.KeyboardEvent) => {
    if (key === Key.SPACE || key === Key.ENTER) {
      onClose();
    }
  };

  return (
    <div
      className={styles.modalContent}
      onClick={e => e.stopPropagation()}
      onKeyDown={handleKeyDown}
      data-testid="modal__modal"
      role="dialog"
      aria-modal="true"
      {...props}
    >
      {showCloseIcon && (
        <div className={styles.modalHeader}>
          <div
            role="button"
            id={`close-modal-custom-${type}`}
            aria-label="Modal Close Button"
            className="ph3-ns pt3-ns pb2-ns ph2 pt4-s pb1 br2 hover-b--transparent mw2"
            onKeyPress={handleKeyPress}
            onClick={onClose}
            tabIndex={0}
          >
            <IconClose size={20} color="black" />
          </div>
        </div>
      )}
      {showBackIcon && (
        <div className={styles.modalHeader}>
          <div
            role="button"
            id={`back-modal-custom-${type}`}
            aria-label="Modal Close Button"
            className="ph3-ns pt3-ns pb2-ns ph2 pt4-s pb1 br2 hover-b--transparent mw2"
            onKeyPress={() => null}
            onClick={onClickBack}
            tabIndex={0}
          >
            <IconArrowBack size={20} color="black" />
          </div>
        </div>
      )}
      <div className={styles.modalBody}>
        <div className={styles.modalChildrenContent}>{children}</div>
      </div>
    </div>
  );
}
